import Utils from '@packages/utils/utils.js';
import EventBus from '@packages/utils/eventBus.js';
import Extends from '@packages/utils/extends.js';
import RAF from '@packages/utils/requestAnimationFrame.js';

var ACTIONS = {
  START: 'START',
  SPIN_ROTATE: 'SPIN_ROTATE',
  SPIN_ZOOMOUT: 'SPIN_ZOOMOUT',
  ARC_ZOOMIN: 'ARC_ZOOMIN',
  TICK_DRAW: 'TICK_DRAW',
  END: 'END'
}

var Point = function (x, y) {
  this.x = x;
  this.y = y;
}

var Loading = function (el, options) {
  this.wrapper = (typeof el === 'string' ? document.querySelector(el) : el);
  var defaults = {
    background: '#FFF',
    spin: {
      lines: 8,
      speed: 1000,
      zoomSpeed: 1500
    },
    arc: {
      zoomSpeed: 1000
    },
    tick: {
      AToB: 4,
      BToC: 8
    },
    onSuccess: Utils.noop
  }
  this.options = defaults;
  Extends(this.options, options);
  this.unique = this.options.unique || Utils.getUnique();
  this.ACTIONS = ACTIONS;
  this.action = ACTIONS.START;
  this.requestId = null;
  this._init();
}

Loading.prototype = {
  _init: function () {
    var self = this;
    self._createCanvas();
    self.observer = EventBus.create(self.unique);
    self._addEvent();
  },
  _createCanvas: function () {
    var self = this;
    var _wrapper = self.wrapper;
    var _canvas = document.createElement('canvas');
    var _ctx = _canvas.getContext('2d');
    _wrapper.appendChild(_canvas);
    var _width = _wrapper.clientWidth;
    var _height = _wrapper.clientHeight;
    self._setCanvasWH(_canvas, _ctx, _width, _height);
    _ctx.fillStyle = self.options.background;
    _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
    self._canvas = _canvas;
    self._ctx = _ctx;
    self.width = _width;
    self.height = _height;
    self._setConfig();
    self.path = self._createTickPath(self.radius);
  },
  // 设置canvas的宽高
  _setCanvasWH: function (canvas, ctx, width, height) {
    var self = this;
    var ratio = self._calculatePixelRatio(ctx);
    if (ratio !== 1) {
      canvas.width = width * ratio;
      canvas.height = height * ratio;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.scale(ratio, ratio);
    } else {
      canvas.width = width;
      canvas.height = height;
    }
  },
  _setConfig: function () {
    var self = this;
    self.action = ACTIONS.START;
    self.currentSpin = 0;
    self.currentSpinZoom = 1;
    self.currentArcZoom = 0;
    self.currentPath = 1;
    self.currentTickPoint = 10;
    self.options.spin.width || (self.options.spin.width = self.width / 15);
    self.options.tick.width || (self.options.tick.width = self.width / 15);
    var radius = self.width / 2.5;
    self.radius = radius;
    // 打钩的三个关键点
    self.A = new Point(-1 * radius / 2, radius / 20);
    self.B = new Point(-1 * radius / 20, radius / 2);
    self.C = new Point(radius / 2, -1 * radius / 3);
  },
  // 解决retina屏下绘制图像模糊
  _calculatePixelRatio: function (ctx) {
    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = ctx.webkitBackingStorePixelRatio ||
      ctx.mozBackingStorePixelRatio ||
      ctx.msBackingStorePixelRatio ||
      ctx.oBackingStorePixelRatio ||
      ctx.backingStorePixelRatio || 1;
    return devicePixelRatio / backingStoreRatio;
  },
  _addEvent: function () {
    var self = this;
    window['addEventListener']('resize', this, false);
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self)
        }
      }
    }
  },
  _onResize: function (e) {
    console.log('resize');
  },
  _createTickPath: function (radius) {
    var self = this;
    var path = [];
    var A = self.A;
    var B = self.B;
    var C = self.C;
    var AToB = self.options.tick.AToB;
    var ABK = (B.y - A.y) / (B.x - A.x);
    var ABXLength = Math.abs(B.x - A.x);
    var BToC = self.options.tick.BToC;
    var BCK = (C.y - B.y) / (C.x - B.x);
    var BCXLength = Math.abs(C.x - B.x);
    path.push(A);
    var i = 0;
    var x = 0;
    var y = 0;
    for (i = 0; i < AToB; i++) {
      x = A.x + (i + 1) * ABXLength / (AToB + 1);
      y = A.y + ABK * (i + 1) * ABXLength / (AToB + 1);
      path.push(new Point(x, y));
    }
    path.push(B);
    for (i = 0; i < BToC; i++) {
      x = B.x + (i + 1) * BCXLength / (BToC + 1);
      y = B.y + BCK * (i + 1) * BCXLength / (BToC + 1);
      path.push(new Point(x, y));
    }
    path.push(C);
    return path;
  },
  _drawLine: function (start, end) {
    var self = this;
    var _ctx = self._ctx;
    _ctx.beginPath();
    _ctx.moveTo(start.x, start.y);
    _ctx.lineTo(end.x, end.y);
    _ctx.lineCap = 'round';
    _ctx.lineJoin = 'round'
    _ctx.lineWidth = self.options.tick.width;
    _ctx.strokeStyle = '#FFF';
    _ctx.closePath();
    _ctx.stroke();
  },
  _drawSpin: function () {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    var rotation = 360 / self.options.spin.lines;
    _ctx.save();
    _ctx.clearRect(0, 0, width, height);
    _ctx.translate(width / 2, height / 2);
    var opacity = 1;
    var i = 0;
    for (i = 0; i < self.currentSpin; i++) {
      _ctx.beginPath();
      _ctx.rotate(-1 * rotation * Math.PI / 180);
      _ctx.moveTo(0, -1 * width / 6);
      _ctx.lineTo(0, -1 * width / 3);
      _ctx.lineCap = 'round';
      _ctx.lineWidth = self.options.spin.width;
      if (self.currentSpin - i < 1) {
        opacity = self.currentSpin - i;
      }
      _ctx.strokeStyle = 'rgba(80, 140, 238,' + opacity + ')';
      _ctx.stroke();
    }
    _ctx.restore();
    if (self.currentSpin < self.options.spin.lines) {
      self.currentSpin = parseFloat(self.currentSpin) + 100 / self.options.spin.speed;
    } else {
      self.currentSpin = 0;
    }
    // 防止小数精度问题产生的bug
    self.currentSpin = self.currentSpin.toFixed(3);
  },
  _drawSpinZoom: function (callback) {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    _ctx.save();
    _ctx.clearRect(0, 0, width, height);
    _ctx.translate(width / 2, height / 2);
    _ctx.scale(self.currentSpinZoom, self.currentSpinZoom);
    if (self.currentSpinZoom > 0) {
      self.currentSpinZoom -= (100 / self.options.spin.zoomSpeed);
    } else {
      self.currentSpinZoom = 0;
      callback && callback();
    }
    for (var i = 0; i < self.options.spin.lines; i++) {
      _ctx.beginPath();
      _ctx.rotate(Math.PI * 2 / self.options.spin.lines);
      _ctx.moveTo(width / 6, 0);
      _ctx.lineTo(width / 3, 0);
      _ctx.lineCap = 'round';
      _ctx.lineWidth = self.options.spin.width;
      _ctx.strokeStyle = 'rgba(80, 140, 238, 1)';
      _ctx.stroke();
    }
    _ctx.restore();
  },
  _drawArc: function (callback) {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    _ctx.save();
    _ctx.clearRect(0, 0, width, height);
    _ctx.translate(width / 2, height / 2);
    _ctx.scale(self.currentArcZoom, self.currentArcZoom);
    if (self.currentArcZoom < 1) {
      self.currentArcZoom += (100 / self.options.arc.zoomSpeed);
    } else {
      self.currentArcZoom = 1;
    }
    _ctx.arc(0, 0, width / 2.5, 0, 2 * Math.PI, false);
    _ctx.fillStyle = '#508cee';
    _ctx.fill();
    _ctx.restore();
    callback && callback();
  },
  _drawPoint: function (callback) {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    _ctx.save();
    _ctx.translate(width / 2, height / 2);
    var A = new Point(self.A.x, self.A.y - self.currentTickPoint);
    var B = new Point(A.x + 1, A.y + 1);
    self._drawLine(A, B);
    _ctx.restore();
    if (self.currentTickPoint > 0) {
      self.currentTickPoint -= 1.5;
    } else {
      callback && callback();
    }
  },
  _drawTick: function (callback) {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    _ctx.save();
    _ctx.translate(width / 2, height / 2);
    var path = self.path;
    if (self.currentPath < path.length) {
      for (var i = 0; i < self.currentPath; i++) {
        self._drawLine(path[i], path[i + 1]);
      }
      self.currentPath++;
    }
    _ctx.restore();
    if (self.currentPath >= path.length) {
      callback && callback();
    }
  },
  _starAnimation: function () {
    var self = this;
    switch (self.action) {
      case ACTIONS.START:
        self.setAction(ACTIONS.SPIN_ROTATE);
        break;
      case ACTIONS.SPIN_ROTATE:
        self._drawSpin();
        break;
      case ACTIONS.SPIN_ZOOMOUT:
        self._drawSpinZoom(function () {
          self.setAction(ACTIONS.ARC_ZOOMIN);
        });
        break;
      case ACTIONS.ARC_ZOOMIN:
        self._drawArc(function () {
          if (self.currentArcZoom > 0.5) {
            self._drawPoint(function () {
              self.setAction(ACTIONS.TICK_DRAW);
            });
          }
        });
        break;
      case ACTIONS.TICK_DRAW:
        self._drawTick(function () {
          self.setAction(ACTIONS.END);
        });
        break;
      case ACTIONS.END:
        self.observer.emit('onSuccess');
        self._stopAnimation();
        break;
    }
    self.requestId && RAF.requestAnimationFrame(function () {
      self._starAnimation();
    });
  },
  _stopAnimation: function () {
    var self = this;
    RAF.cancelAnimationFrame(self.requestId);
    self.requestId = null;
  },
  handleEvent: function (e) {
    switch (e.type) {
      case 'resize':
        this._onResize(e);
        break;
    }
  },
  setAction: function (actName) {
    var self = this;
    self.action = actName;
  },
  clear: function () {
    var self = this;
    var _canvas = self._canvas;
    var _ctx = self._ctx;
    _ctx.fillStyle = self.options.backgroundColor;
    _ctx.clearRect(0, 0, _canvas.width, _canvas.height);
    _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
  },
  start: function () {
    var self = this;
    self._setConfig();
    self.requestId = RAF.requestAnimationFrame(function () {
      self._starAnimation();
    });
  },
  stop: function () {
    var self = this;
    self._stopAnimation();
  },
  success: function () {
    var self = this;
    self.setAction(ACTIONS.SPIN_ZOOMOUT);
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./packages/components/loading/loading-success.js